const DEFAULT_API_BASE_URL = "https://us-central1-red-flag-or-deal-breaker.cloudfunctions.net";
const DEFAULT_EDGE_PUBLISHABLE_KEY_LIVE =
  "ept_live_bmehzDorrHCMEaWXeGhXsC4q7pYQZ3UyopqZw9JuiDNaYPboJK";
const DEFAULT_EDGE_PUBLISHABLE_KEY_SANDBOX =
  "ept_sandbox_bPzP1Kyyx55aAKUg1vbAZkfdipk6nSGNKGMvxGfwD53c2GDUZj";

function isDevPathRuntime() {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location.href.includes("/dev/");
}

export const IS_DEALFLOW_DEV_RUNTIME = isDevPathRuntime();

const liveEdgePublishableKey =
  process.env.REACT_APP_EDGE_PUBLISHABLE_KEY_LIVE || DEFAULT_EDGE_PUBLISHABLE_KEY_LIVE;
const sandboxEdgePublishableKey =
  process.env.REACT_APP_EDGE_PUBLISHABLE_KEY_SANDBOX || DEFAULT_EDGE_PUBLISHABLE_KEY_SANDBOX;

export const EDGE_CONFIG = {
  publishableKey: IS_DEALFLOW_DEV_RUNTIME ? sandboxEdgePublishableKey : liveEdgePublishableKey,
  sdkUrl:
    "https://assets.tryedge.io/assets/js/edge-3e2372199b3b42473d0f8a29328f1c73.js?vsn=d",
};

export const DEALFLOW_API_BASE_URL =
  process.env.REACT_APP_DEALFLOW_API_BASE_URL || DEFAULT_API_BASE_URL;

export function buildDealflowApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (!IS_DEALFLOW_DEV_RUNTIME) {
    return `${DEALFLOW_API_BASE_URL}${normalizedPath}`;
  }

  if (normalizedPath.startsWith("/rfdb/")) {
    return `${DEALFLOW_API_BASE_URL}${normalizedPath.replace("/rfdb/", "/rfdb/dev/")}`;
  }

  return `${DEALFLOW_API_BASE_URL}/dev${normalizedPath}`;
}
